import React from "react";
import "./index.scss";

/**
 * DocumentUpload — shows existing uploaded file (if any) + new upload input.
 *
 * Props:
 *  label        - field label
 *  name         - input name
 *  file         - newly selected File object (from state)
 *  onChange     - file input change handler
 *  required     - bool
 *  existingFile - { fileName, filePath } from API — shown as already uploaded
 *  onViewExisting - () => void — called when user clicks "View" on existing file
 */
const DocumentUpload = ({
  label,
  name,
  file,
  onChange,
  required = false,
  existingFile = null,
  onViewExisting,
}) => (
  <div className="doc-upload-wrapper">
    <label className="doc-upload-label" htmlFor={name}>
      {label}
      {required && <span className="required-mark"> *</span>}
    </label>

    {/* Show existing uploaded file if present */}
    {existingFile && (
      <div className="doc-upload-existing">
        <span className="doc-upload-existing__icon">✓</span>
        <span
          className="doc-upload-existing__name"
          title={existingFile.fileName}
        >
          {existingFile.fileName}
        </span>
        {onViewExisting && (
          <button
            type="button"
            className="doc-upload-existing__view"
            onClick={onViewExisting}
            title="View uploaded file"
          >
            View
          </button>
        )}
        <span className="doc-upload-existing__hint">Re-upload to replace</span>
      </div>
    )}

    {/* New upload input */}
    <div className={`doc-upload-box ${file ? "has-file" : ""}`}>
      <input
        id={name}
        type="file"
        name={name}
        accept=".pdf,.jpg,.jpeg,.png"
        className="doc-upload-input"
        onChange={onChange}
      />
      <span className="doc-upload-text">
        {file ? file.name : "Click to upload (PDF / JPG / PNG)"}
      </span>
    </div>
  </div>
);

export default DocumentUpload;
